import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Wishlist/WishlistDetail/WishlistShareableDetail.container"
    ).then((module) => ({
        default: module.WishlistShareableDetailContainer
    }))
);
